import { render, staticRenderFns } from "./FeatureFlag.vue?vue&type=template&id=1498722a&scoped=true&"
import script from "./FeatureFlag.vue?vue&type=script&lang=js&"
export * from "./FeatureFlag.vue?vue&type=script&lang=js&"
import style0 from "./FeatureFlag.vue?vue&type=style&index=0&id=1498722a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1498722a",
  null
  
)

export default component.exports